import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/observable/of';

import {environment} from '../../environments/environment';

@Injectable()
export class ConfigurationService {

  private serverUrl = environment.serverUrl;

  constructor(private http: HttpClient) {
  }

  getConfigurations(): Observable<any> {
    const reqEndPoint = 'configurations';
    return this.http.get(this.serverUrl + reqEndPoint);
  }

  tokenTest(): Observable<any> {
    const reqEndPoint = 'users/tokentest';
    return this.http.get(this.serverUrl + reqEndPoint);
  }

  getUTCTime(): Observable<any> {
    return this.http.get(this.serverUrl + 'utctime');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/config.service.ts